import HttpService from "./htttp.service";
import HttpDRService from "./httpdr.service";

class ProfileService {
  // Method to save the profile to the backend
  async saveProfile(platform, profileData) {
    try {
      const payload = {
        data: {
          type: "profiles",
          attributes: profileData,
        },
      };
      const response = await HttpService.post(`/platform/${platform.toLowerCase()}/profile/save`, payload);
      return response.data;
    } catch (error) {
      console.error("Error saving profile:", error);
      throw error;
    }
  }

  // Accepts platform and an optional array of profile IDs
  async fetchProfile(platform, profileIds = [], id = "") {
    try {
      let endpoint = id
        ? `/platform/${platform.toLowerCase()}/profile/${id}`
        : `/platform/${platform.toLowerCase()}/profile`;
    
      if (!id && Array.isArray(profileIds) && profileIds.length > 0) {
        const idsParam = profileIds.join(",");
        endpoint += `?profile_ids=${idsParam}`;
      }
      const response = await HttpService.get(endpoint);
      return response;
    } catch (error) {
      console.error("Error fetching profiles:", error);
      throw error;
    }
  }


  // Method: Delete Selected Profiles**
  async deleteProfiles(platform, profileIds) {
    try {
      if (!Array.isArray(profileIds) || profileIds.length === 0) {
        throw new Error("No profile IDs provided for deletion.");
      }

      const payload = {
        data: {
          type: "profiles",
          attributes: {
            profileIds,
          },
        },
      };

      // Use HttpService's `delete` method with proper platform-specific URL and payload
      const response = await HttpService.delete(`/platform/${platform.toLowerCase()}/profile/delete`,payload);
      return response;
    } catch (error) {
      console.error(`Error deleting profiles for platform: ${platform}`, error);
      throw error;
    }
  }


    // // Accepts platform and an optional array of profile IDs
    // async refreshProfile(platform, profileIds = [], id = "") {
    //   try {
    //     let endpoint = id
    //       ? `/platform/${platform.toLowerCase()}/profile/${id}`
    //       : `/platform/${platform.toLowerCase()}/profile`;
      
    //     if (!id && Array.isArray(profileIds) && profileIds.length > 0) {
    //       const idsParam = profileIds.join(",");
    //       endpoint += `?profile_ids=${idsParam}`;
    //     }
  
    //     const response = await HttpDRService.get(endpoint);
    //     console.log("Backend Response:", response);
    //     return response;
    //   } catch (error) {
    //     console.error("Error refreshing profiles:", error);
    //     throw error;
    //   }
    // }

    // // Accepts platform, an optional array of profile IDs, optional single ID, and optional refresh type
    // async refreshProfile(platform, profileIds = [], id = "", refreshType = "") {
    //   try {
    //     let endpoint = id
    //       ? `/platform/${platform.toLowerCase()}/profile/${id}`
    //       : `/platform/${platform.toLowerCase()}/profile`;

    //     const queryParams = [];

    //     if (!id && Array.isArray(profileIds) && profileIds.length > 0) {
    //       const idsParam = profileIds.join(",");
    //       queryParams.push(`profile_ids=${idsParam}`);
    //     }

    //     if (refreshType) {
    //       queryParams.push(`refresh_type=${refreshType}`);
    //     }

    //     if (queryParams.length > 0) {
    //       endpoint += `?${queryParams.join("&")}`;
    //     }

    //     const response = await HttpDRService.get(endpoint);
    //     console.log("Backend Response:", response);
    //     return response;
    //   } catch (error) {
    //     console.error("Error refreshing profiles:", error);
    //     throw error;
    //   }
    // }

  
}

export default new ProfileService();
